import { TrackingConstants } from './../../../shared/services/tracking/tracking-constants.service';
import { MessageService } from './../../../services/messages.service';
import { EntityTransactionMonitoringService } from './../entity-transaction-monitoring.service';
import { OnInit } from '@angular/core/';
import { MdDialogRef } from '@angular/material';
import { SnackBarService } from './../../../services/snackbar.service';
import { TrackingService } from './../../../shared/services/tracking/google-analytics-events.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { TaskService } from 'app/task/task.service';
import { ApplicationValue } from './../../../services/warmup/application-type.model';
import { Component } from '@angular/core';
import { UpdateTransactionStatus } from './update-transaction-model';

@Component({
    templateUrl: 'update-transaction-status.component.html',
    styleUrls: ['update-transaction-status.component.css']
})
export class UpdateTransactionStatusComponent implements OnInit {
    tranctionsStatus: ApplicationValue[];
    selectedSingleTransactionStatus: any;
    selectedSingleTransaction = [];
    transactionids: any;
    private transactionStatusForm: FormGroup;
    constructor(
        private taskService: TaskService,
        private trackingService: TrackingService,
        private snackBarService: SnackBarService,
        private formBuilder: FormBuilder,
        public dialogRef: MdDialogRef<any>,
        public entityTransactionMonitoringService: EntityTransactionMonitoringService,
    ) { }

    ngOnInit() {
        this.transactionStatusForm = this.formBuilder.group({
            remark: [''],
            tranctionStatus: [''],
        });
    }

    update({ value, valid }) {
        this.dialogRef.close();
        const updateTransactionStatus = new UpdateTransactionStatus;
        updateTransactionStatus.status = value.tranctionStatus;
        updateTransactionStatus.remark = value.remark;
        if (this.selectedSingleTransaction.length > 0) {
            updateTransactionStatus.transactionIds = this.selectedSingleTransaction;
        } else {
            updateTransactionStatus.transactionIds = this.transactionids;
        }
        this.entityTransactionMonitoringService.updateTransactionsStatus(updateTransactionStatus).subscribe(
            success => {
                this.entityTransactionMonitoringService.sendBroadCastToLoadTransactionRecords(true);
                this.callSnackBarService(success);
                this.trackingService
                    .emitEvent(TrackingConstants.TRANSACTIONS, TrackingConstants.PERFORM_UPDATE_TRANSACTIONS_STATUS,
                    TrackingConstants.SUCCESS, 1);
            },
            err => {
                this.callSnackBarService(err);
                this.trackingService
                    .emitEvent(TrackingConstants.TRANSACTIONS, TrackingConstants.PERFORM_UPDATE_TRANSACTIONS_STATUS,
                    TrackingConstants.FAILURE, 0);
            }
        );
    }

    callSnackBarService(response: any) {
        this.snackBarService.showStatus(response,
            MessageService.TRANSACTION_STATUS_UPDATE_SUCCESS,
            MessageService.TRANSACTION_STATUS_UPDATE_FAILURE);
    }

}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-monitoring/update-transaction-status/update-transaction-status.component.ts